import { UPDATE_SENDGRID_API_KEY } from "@/components/email/internal/ducks/Actions"
import { apiUpdateSendgridApiKey } from "@/components/email/internal/ducks/AJAX"

export default () => (next) => (action) => {
  switch (action.type) {
    case UPDATE_SENDGRID_API_KEY:
      apiUpdateSendgridApiKey(action.success, action.error)
      return next(action)

    default:
      return next(action)
  }
}
